import React from 'react';
import { DemoFlowContextProvider } from './DemoFlowContextProvider';
import { FiltersContextProvider } from './FiltersContextProvider';
import { LeftSidePanelContextProvider } from './LeftSidePanelContextProvider';
import { MapContextProvider } from './MapContextProvider';
import { MapEventsContextProvider } from './MapEventsContextProvider';
import { PanelSourcesProvider } from './PanelSourcesProvider';

export const ContextsProviders: React.FC<React.PropsWithChildren> = ({ children }) => (
  <MapContextProvider>
    <DemoFlowContextProvider>
      <FiltersContextProvider>
        <LeftSidePanelContextProvider>
          <MapEventsContextProvider>
            <PanelSourcesProvider>{children}</PanelSourcesProvider>
          </MapEventsContextProvider>
        </LeftSidePanelContextProvider>
      </FiltersContextProvider>
    </DemoFlowContextProvider>
  </MapContextProvider>
);
